import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "../src/main-component/App/App";
import reportWebVitals from "./reportWebVitals";
import { ParallaxProvider } from "react-scroll-parallax";
import "./i18n";
import "./css/font-awesome.min.css";
import "./css/themify-icons.css";
import "./css/animate.css";
import "./css/flaticon.css";
import "./sass/style.scss";

import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/index";
import { Provider } from "react-redux";
import CmsProvider from "./config/CmsProvider";
import BlogProvider from "./config/BlogProvider";
import { ImageKitProvider } from "@imagekit/react";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <CmsProvider>
        <BlogProvider>
          <HelmetProvider>
            <ImageKitProvider urlEndpoint="https://ik.imagekit.io/ndshetunf">
              <ParallaxProvider>
                <Suspense fallback={null}>
                  <App />
                </Suspense>
              </ParallaxProvider>
            </ImageKitProvider>
          </HelmetProvider>
        </BlogProvider>
      </CmsProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
